module.exports = __webpack_public_path__ + "img/logo1 (39).3425c73d.jpg";